import {makeVar} from "@apollo/client";

export const userPreferencesVar = makeVar({});